module.exports = __webpack_public_path__ + "static/slr-zoom-7e393274ce79989cceffb0c662307c68.jpg";